module.exports = __webpack_public_path__ + "img/skating007.b7da23a3.jpg";